module.exports = __webpack_public_path__ + "img/1-8.791d75ba.png";